export const featuresPathPrefix = '/objective_';
export const sortkeyPathPrefix = '/sortkey_';
export const pageNumberPathPrefix = '/page_';
